import script from "./player.vue?vue&type=script&setup=true&lang=ts"
export * from "./player.vue?vue&type=script&setup=true&lang=ts"

import "./player.vue?vue&type=style&index=0&id=5ab44b55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab44b55"]])

export default __exports__